import React from "react";

import TextFieldController from "../forms/TextFieldController";

const HistoryForm = ({ control }) => {
  return (
    <>
      <div className="row">
        <label className="form-group-label">
          Vues sur site internet L&P<span>*</span>
        </label>
        <TextFieldController
          control={control}
          name="history.websiteView"
          type="number"
          disabled
        />
      </div>
      <div className="row">
        <label className="form-group-label text-red">
          Leads reçus - Promoteur<span>*</span>
        </label>
        <TextFieldController
          control={control}
          name="history.leadReceived.promoter"
          type="number"
          className="required"
        />
      </div>
      <div className="row">
        <label className="form-group-label">
          Leads reçus - DB L&P<span>*</span>
        </label>
        <TextFieldController
          control={control}
          name="history.leadReceived.whise"
          type="number"
          disabled
        />
      </div>
      <div className="row">
        <label className="form-group-label">
          Leads reçus - Site internet<span>*</span>
        </label>
        <TextFieldController
          control={control}
          name="history.leadReceived.website"
          type="number"
          disabled
        />
      </div>
      <div className="row">
        <label className="form-group-label">
          Contacts téléphoniques<span>*</span>
        </label>
        <TextFieldController
          control={control}
          name="history.calls"
          type="number"
          disabled
        />
      </div>
      <div className="row">
        <div className="col">
          <label className="col-sm-12 form-group-label">
            Visite - Chantier<span>*</span>
          </label>
          <div className="col-sm-12">
            <TextFieldController
              control={control}
              name="history.visits.worksite"
              disabled
            />
          </div>
        </div>
        <div className="col">
          <label className="col-sm-12 form-group-label">
            Visite - Bureau<span>*</span>
          </label>
          <div className="col-sm-12">
            <TextFieldController
              control={control}
              name="history.visits.office"
              disabled
            />
          </div>
        </div>
      </div>
      <div className="row">
        <label className="form-group-label">
          Rendez-vous<span>*</span>
        </label>
        <TextFieldController
          control={control}
          name="history.appointments"
          type="number"
          disabled
        />
      </div>
      <div className="row">
        <label className="form-group-label text-red">
          Offres reçues<span>*</span>
        </label>
        <TextFieldController
          control={control}
          name="history.offersReceived"
          type="number"
          className="required"
        />
      </div>
      <div className="row">
        <label className="form-group-label text-red">
          Offres acceptées<span>*</span>
        </label>
        <TextFieldController
          control={control}
          name="history.acceptedOffers"
          type="number"
          className="required"
        />
      </div>
      <div className="row">
        <label className="form-group-label">
          Compromis signés<span>*</span>
        </label>
        <TextFieldController
          control={control}
          name="history.signedCompromises"
          type="number"
        />
      </div>
    </>
  );
};

export default HistoryForm;
